import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { faSquareDollar } from '@fortawesome/pro-light-svg-icons/faSquareDollar';
import { faSquareList } from '@fortawesome/pro-light-svg-icons/faSquareList';
import { faSquarePlus } from '@fortawesome/pro-light-svg-icons/faSquarePlus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
export function Content({ moduleType, isSelected }) {
    const { t } = useTranslation();
    const modules = {
        main: {
            id: 'main-module',
            label: t('modules.choose_module_type.main.name'),
            description: t('modules.choose_module_type.main.description'),
            icon: faSquareList
        },
        extra: {
            id: 'extra-module',
            label: t('modules.choose_module_type.additional.name'),
            description: t('modules.choose_module_type.additional.description'),
            icon: faSquarePlus
        },
        paidModule: {
            id: 'paid-module',
            label: t('modules.choose_module_type.additional_paid.name'),
            description: t('modules.choose_module_type.additional_paid.description'),
            icon: faSquareDollar
        }
    };
    const { label, icon, description } = modules[moduleType];
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: clsx('transition-smooth mb-3 h-8 w-8 rounded-large p-3', {
                    'bg-primary-500': isSelected,
                    'bg-neutral-100 group-hover:bg-neutral-200 group-active:bg-neutral-200': !isSelected
                }), children: _jsx(FontAwesomeIcon, { icon: icon, className: clsx('h-5 w-5', {
                        'text-neutral-0': isSelected,
                        'text-neutral-500': !isSelected
                    }) }) }), _jsx("p", { className: clsx('mb-3 mt-2 text-small font-bold', {
                    'text-neutral-900': isSelected,
                    'text-neutral-600': !isSelected
                }), children: label }), _jsx("p", { className: clsx('w-[280px] text-center text-small', {
                    'text-neutral-800': isSelected,
                    'text-neutral-500': !isSelected
                }), children: description })] }));
}
